<template>
  <div class="QHloading flex-center" v-if="loading">
    <div class="mapBox">
      <div class="mapBG map1"><img src="./images/lbx.png" /></div>
      <div class="mapBG map2"><img src="./images/jt.png" /></div>
      <div class="mapBG map3"><img src="./images/map.png" /></div>
    </div>
  </div>
</template>

<script>
export default {
  // +----------------------------------------------------------------------
  // | Desc:data
  // +----------------------------------------------------------------------
  data() {
    return {
      values: [],
    };
  },

  // +----------------------------------------------------------------------
  // | Desc:props
  // +----------------------------------------------------------------------
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
<style>
/*QHloading*/
.QHloading {
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 100000;
  background: radial-gradient(circle, #0c96ff, #092654);
}
.QHloading .mapBox {
  width: 500px;
  height: 500px;
  position: relative;
}
.QHloading .mapBG {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.QHloading .mapBG img {
  width: 100%;
  height: 100%;
}
.QHloading .map1 {
  animation: myfirst2 15s infinite linear;
  z-index: 2;
}
.QHloading .map2 {
  animation: myfirst 10s infinite linear;
  z-index: 3;
}
.QHloading .map2 img {
  transform: scale(0.7);
}
.QHloading .map3 {
  opacity: 0.2;
  transform: scale(0.6);
  opacity: 0.6;
  z-index: 1;
}
@keyframes myfirst {
  from {
    transform: rotate(0deg) scale(0.8);
  }
  to {
    transform: rotate(-359deg) scale(0.8);
  }
}
@keyframes myfirst2 {
  from {
    transform: rotate(0deg) scale(0.8);
  }
  to {
    transform: rotate(359deg) scale(0.8);
  }
}
</style>
